import { useEffect, useState } from 'react'

export default function DateRangeFilterModal({
	isOpen,
	onClose,
	fromDate: initialFromDate = '',
	toDate: initialToDate = '',
	onApply,
	title = 'Filtruj po dacie',
	description = 'Wybierz zakres dat, aby zawezic liste.',
	fromLabel = 'Data od',
	toLabel = 'Data do',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
	cancelLabel = 'Anuluj',
	invalidRangeMessage = 'Data poczatkowa nie moze byc pozniejsza niz data koncowa.',
}) {
	const [fromDate, setFromDate] = useState('')
	const [toDate, setToDate] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		if (!isOpen) return

		setFromDate(initialFromDate || '')
		setToDate(initialToDate || '')
		setError('')
	}, [isOpen, initialFromDate, initialToDate])

	if (!isOpen) return null

	const validateRange = () => {
		if (fromDate && toDate && fromDate > toDate) {
			setError(invalidRangeMessage)
			return false
		}

		setError('')
		return true
	}

	const handleApply = () => {
		if (!validateRange()) return

		onApply(fromDate || null, toDate || null)
	}

	const handleClear = () => {
		onApply(null, null)
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<div className="border-b border-gray-200 p-4">
					<h3 className="text-base font-semibold text-gray-900">{title}</h3>
					<p className="mt-1 text-sm text-gray-500">{description}</p>
				</div>
				<div className="space-y-4 p-4">
					<div>
						<label htmlFor="date-range-from" className="mb-1 block text-sm font-medium text-gray-700">
							{fromLabel}
						</label>
						<input
							id="date-range-from"
							type="date"
							value={fromDate}
							onChange={event => {
								setFromDate(event.target.value)
								setError('')
							}}
							className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
						/>
					</div>
					<div>
						<label htmlFor="date-range-to" className="mb-1 block text-sm font-medium text-gray-700">
							{toLabel}
						</label>
						<input
							id="date-range-to"
							type="date"
							value={toDate}
							onChange={event => {
								setToDate(event.target.value)
								setError('')
							}}
							className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
						/>
					</div>
					{error ? <p className="text-sm text-red-600">{error}</p> : null}
				</div>
				<div className="flex justify-between border-t border-gray-200 p-4">
					<button
						type="button"
						onClick={handleClear}
						className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
					>
						{clearLabel}
					</button>
					<div className="flex gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
						>
							{cancelLabel}
						</button>
						<button
							type="button"
							onClick={handleApply}
							className="rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
						>
							{applyLabel}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}
